import { PacketType } from "../enum/PacketType";
import Engine from "./Engine";
import MonoBehavior from "./MonoBehavior";
import NetEngine from "./NetEngine";

export default class NetworkBehavior extends MonoBehavior {
    get engine(): NetEngine {
        return this.gameObject.engine as NetEngine;
    }

    get isHost() {return this.engine.isHost;}
    
    isOwner = true;

    SyncTransform() {
        this.engine.sendUpdateTransformPacket(this.gameObject);
    }
}